import styles from "./Modal.module.scss";

const Modal = ({
  children,
  style,
  setModalOpen,
  center,
  darkBg,
  whiteBg,
  blockExit,
}) => {
  return (
    <>
      <div
        className={`${styles.bg} ${darkBg ? styles.darkBg : ""} ${
          whiteBg ? styles.whiteBg : ""
        }`}
        onClick={() => !blockExit && setModalOpen(false)}
      />
      <div
        className={`${center ? styles.center : ""} ${
          whiteBg ? styles.wrap_white : styles.wrap
        }`}
        style={style}
      >
        {children}
      </div>
    </>
  );
};

export default Modal;
